var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "#F4F4F4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 27.5C19.1 27.5 20 26.6 20 25.5H16C16 26.6 16.89 27.5 18 27.5ZM24 21.5V16.5C24 13.43 22.36 10.86 19.5 10.18V9.5C19.5 8.67 18.83 8 18 8C17.17 8 16.5 8.67 16.5 9.5V10.18C13.63 10.86 12 13.42 12 16.5V21.5L10 23.5V24.5H26V23.5L24 21.5Z",
    fill: "#545554"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.2c514ca6dbd30d96ba544b8c1657e6bf.svg";
export { ForwardRef as ReactComponent };